import React from 'react';
import { UrgencyBar } from './UrgencyBar';
export function Pricing() {
  return <section className="py-[60px] px-5 bg-dark" data-id="element-106">
      <div className="max-w-[760px] mx-auto" data-id="element-107">
        <UrgencyBar data-id="element-108" />
        <br data-id="element-109" />
        <h2 className="text-[22px] md:text-[34px] font-black text-center mb-3 text-text-heading mt-4" data-id="element-110">
          ELEGÍ TU <span className="text-gold" data-id="element-111">MISIÓN INFLUENCIA</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-8" data-id="element-112">
          {/* Esencial */}
          <div className="bg-card border border-cardBorder rounded-2xl p-8 text-center relative hover:border-gold/50 transition-colors" data-id="element-113">
            <p className="text-[13px] tracking-[3px] text-gold font-bold mb-2" data-id="element-114">
              MISIÓN INFLUENCIA
            </p>
            <p className="text-xl font-black text-white mb-1.5" data-id="element-115">ESENCIAL</p>
            <p className="text-[13px] text-[#888] mb-5" data-id="element-116">
              6 Tomos + 5 Bonos Gratis
            </p>
            <p className="text-[15px] text-[#555] line-through mb-1" data-id="element-117">$49.000</p>
            <p className="text-[38px] font-black text-gold mb-1" data-id="element-118">$19.000</p>
            <p className="text-[14px] text-[#888] mb-6" data-id="element-119">ARS</p>
            <a href="https://www.stockdigital.shop/checkouts/cn/hWNC0JGtZ4UXGzFFtqS60pr0/es-ar?_r=AQABgqRKz8X0FzFMzgg2iw3bFO43mKzRGrYWJsB1MM2QPv4&cart_link_id=vPJR0qhR&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="block bg-transparent border-2 border-gold text-gold font-black text-[15px] py-4 px-6 rounded-full no-underline transition-transform duration-200 hover:scale-[1.03]" data-id="element-120">
              → QUIERO EL ESENCIAL
            </a>
          </div>

          {/* Completo */}
          <div className="bg-card border-2 border-gold shadow-[0_0_30px_rgba(201,168,76,0.2)] rounded-2xl p-8 text-center relative" data-id="element-121">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-gold-gradient text-base font-black text-[12px] py-1 px-4 rounded-full whitespace-nowrap" data-id="element-122">
              ⭐ MÁS ELEGIDO
            </div>
            <p className="text-[13px] tracking-[3px] text-gold font-bold mb-2" data-id="element-123">
              MISIÓN INFLUENCIA
            </p>
            <p className="text-xl font-black text-white mb-1.5" data-id="element-124">COMPLETO</p>
            <p className="text-[13px] text-[#888] mb-5" data-id="element-125">
              6 Tomos + 5 Bonos + 5 Módulos Avanzados
            </p>
            <p className="text-[15px] text-[#555] line-through mb-1" data-id="element-126">$98.000</p>
            <p className="text-[38px] font-black text-gold mb-1" data-id="element-127">$27.000</p>
            <p className="text-[14px] text-[#888] mb-6" data-id="element-128">ARS</p>
            <a href="https://www.stockdigital.shop/checkouts/cn/hWNC0JjlP8Cgi0TOiEBMJahW/es-ar?_r=AQABl53XfnJuUoQlYTYA1OzFYJvH1lnvoCApAL-3pOqOIT0&cart_link_id=QH8Ec45e&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="block bg-gold-gradient text-base font-black text-[15px] py-4 px-6 rounded-full no-underline transition-transform duration-200 hover:scale-[1.03]" data-id="element-129">
              → QUIERO EL COMPLETO
            </a>
          </div>
        </div>

        <h3 className="text-center text-gold my-10 text-base font-bold" data-id="element-130">
          ¿Qué agrega el Pack Completo?
        </h3>

        <div className="overflow-x-auto" data-id="element-131">
          <table className="w-full border-collapse mt-8 text-[14px]" data-id="element-132">
            <thead data-id="element-133">
              <tr data-id="element-134">
                <th className="bg-[#1a1a2e] text-gold p-3 px-4 text-left font-bold" data-id="element-135">
                  SITUACIÓN
                </th>
                <th className="bg-[#1a1a2e] text-gold p-3 px-4 text-left font-bold" data-id="element-136">
                  SIN SISTEMA
                </th>
                <th className="bg-[#1a1a2e] text-gold p-3 px-4 text-left font-bold" data-id="element-137">
                  CON SISTEMA COMPLETO
                </th>
              </tr>
            </thead>
            <tbody data-id="element-138">
              {[['No sabés qué publicar', 'Improvisás o no publicás', '52 semanas de contenido resuelto'], ['Alguien te responde un DM', 'No sabés qué decir', '50 scripts listos para usar'], ['Tu cuenta se ve amateur', 'Perdés credibilidad', 'Sistema visual premium desde hoy'], ['Querés hablar de Dios', 'Tenés miedo al rechazo', 'Método que conecta sin imponer'], ['Publicás y nadie responde', 'Frustración y abandono', 'Estructura probada de alto impacto']].map((row, i) => <tr key={i} className={i % 2 !== 0 ? 'bg-[#0f0f1a]' : ''} data-id="element-139">
                  <td className="p-3 px-4 border-b border-divider text-text-secondary" data-id="element-140">
                    {row[0]}
                  </td>
                  <td className="p-3 px-4 border-b border-divider text-[#666]" data-id="element-141">
                    {row[1]}
                  </td>
                  <td className="p-3 px-4 border-b border-divider text-gold font-semibold" data-id="element-142">
                    {row[2]}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}